'use client';

import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ITheme, Responsive, UnstyledUl } from '../../../ui';
import { Color } from '../../../styles/Color';

interface ICardsContainer {
	columns?: number;
	columnsMobile?: number;
	removeCardBorder?: boolean;
	children: ReactNode;
}

export default function CardsContainer({
	columns,
	columnsMobile,
	removeCardBorder,
	children,
}: ICardsContainer) {
	return (
		<StyledCardsContainer
			columns={columns}
			columnsMobile={columnsMobile}
			removeCardBorder={removeCardBorder}
			className="cards-container"
		>
			{children}
		</StyledCardsContainer>
	);
}

export const StyledCardsContainer = styled(UnstyledUl)<
	{
		columns?: number;
		columnsMobile?: number;
		removeCardBorder?: boolean;
	},
	ITheme
>`
	display: grid;
	grid-column-gap: ${(props) => props.theme.grid?.gutter?.vertical?.default};
	grid-row-gap: ${(props) => props.theme.grid?.gutter?.horizontal?.default};
	padding: 0;
	margin: 0;
	grid-template-columns: ${({ columns }) =>
		columns ? `repeat(${columns}, 1fr)` : `repeat(3, 1fr)`};

	> li {
		margin-top: 0;
		min-width: 0;
		${({ removeCardBorder }) =>
			!removeCardBorder && `border: 1px solid ${Color.BorderCard};`}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: ${({ columnsMobile }) =>
			columnsMobile ? `repeat(${columnsMobile}, 1fr)` : '1fr'};
		grid-row-gap: ${(props) => props.theme.grid?.gutter?.horizontal?.mobile};
	}
`;
